import cn from 'classnames'
import Modal from 'react-modal'
import Loader from '../components/Loader'
import Button from '../components/Button'
import { useCallback } from 'react'

/**
 * ModalMessage component for Attact Loop with loader and message display.
 *
 * @param {String|null} param.state
 * @param {Function} param.closeModal
 * @returns
 */
const ModalMessage = ({ state, closeModal }) => {
  const getContent = useCallback(() => {
    // defaults to loading state
    if (!state?.length || state === 'Loading') {
      return <Loader container={false} />
    }

    return (
      <>
        <div className="modal__copy">{state}</div>
        <div className="modal__actions">
          <Button className="btn -primary" onClick={closeModal} title="OK" />
        </div>
      </>
    )
  }, [state, closeModal])

  if (!state) {
    return null
  }

  return (
    <Modal
      className={cn('modal', { '-padding-bottom': !!state })}
      isOpen={!!state}
      onRequestClose={closeModal}
      overlayClassName="overlay -higher-layer"
    >
      {getContent()}
    </Modal>
  )
}

export default ModalMessage
